// 드라이브(Nextcloud Files) 머리 줄을 없애고 [NC 원본 열기(관리자)] [AI] [종] 묶음을 본문 첫 줄 오른쪽 끝으로 옮긴다
// — 2026-10-28 지윤 요청(req-20261028-175403-e48a66 «빨간 박스 안 아이콘·텍스트 삭제» · 옮길 자리는 맡김).
// 첫 줄 = 경로·새로 만들기·보기 전환이 있는 줄(NC .files-list__header). 오른쪽 상세 칸이 열리면 같이 줄어 닫기 단추를
// 가리지 않는다(고정 위치로 띄우면 가린다). 게이트웨이 상단 바는 모바일 임베드·보조 칸에 없어서 거기 두지 않는다.
// 🔴 NC 는 안 고친다. 같은 오리진 iframe 문서에 style 과 묶음을 넣고, 종(#notifications)은 NC 요소를 옮기기만 한다
//    (새로 만들지 않는다 — 개수 배지·알림 기능은 NC 것 그대로).
// 🔴 머리 줄은 파일 앱 문서(#content.app-files · #content-vue.app-files)에서만 숨긴다 — 드라이브 iframe 안에서 넘어간
//    캘린더 등은 머리 줄을 그대로 두고, 묶음은 머리 줄 오른쪽(.header-end)에 남는다.
// 🔴 Vue 가 첫 줄을 다시 그리면 묶음이 문서에서 떨어진다(getElementById 로 못 찾는다) → 묶음 참조는 doc 속성에 들고,
//    body 옵저버(150ms 디바운스)가 다시 붙인다 — EmbedPage 폴링(약 6초)이 끝난 뒤에도.
// 🔴 CSS 문자열 안에 /* */ 주석을 넣지 않는다(collabSkinNc 와 같은 규약 — 시험 해석기가 주석을 셀렉터로 읽는다).
// 실측 전 가정(D3 실제 NC 시험만 확정): --header-height 를 어느 요소에 선언하는지 · 알림 창(.header-menu__wrapper)의
//   position · 첫 줄 클래스(.files-list__header) · 종 트리거·꼬리 클래스(@nextcloud/vue 9 NcHeaderMenu).
// 전부 try/catch — NC DOM 이 바뀌면 조용히 무동작.
import { BOT_NAME } from './brand';

export const DRIVE_ACTIONS_ID = 'gw-drive-actions';
export const DRIVE_ACTIONS_STYLE_ID = 'gw-drive-actions-css';
export const AI_BTN_ID = 'gw-ai-btn';
export const ORIGIN_BTN_ID = 'gw-nc-orig';
export const BELL_ID = 'notifications';
export const GUARD_KEY = '__gwDriveActions';
export const GROUP_KEY = '__gwDriveActionsGroup';   // 묶음 참조(떨어져도 같은 묶음을 쓴다)
const DEBOUNCE_MS = 150;
const PANEL_GAP_PX = 6;
const HOVER_BG = 'var(--color-background-hover, rgba(0,0,0,.06))';
const FILES_DOC = '#content.app-files,#content-vue.app-files';

export const DRIVE_ACTIONS_CSS = [
  // 머리 줄 제거 — 파일 앱 문서에서만. 서버가 #content.app-files 를 처음부터 그려 첫 페인트부터 숨는다.
  'html:has(' + FILES_DOC + ') #header{display:none !important}',
  // 머리 줄 높이만큼 남는 빈 띠·이중 스크롤 제거 — --body-height 가 :root·body 어디서 계산되든 덮이게 둘 다 건다.
  'html:has(' + FILES_DOC + '),html:has(' + FILES_DOC + ') body{--header-height:0px !important}',
  // 묶음 글자 — 다크 OS 에서 피부(--gw-nc-hdr-fg)가 꺼지면 본문 글자색(흰 본문 위 흰 글자 방지).
  '#' + DRIVE_ACTIONS_ID + '{display:flex;align-items:center;gap:4px;flex-shrink:0;'
    + 'color:var(--gw-nc-hdr-fg,var(--color-main-text,#222222))}',
  // 머리 줄에 남을 때(파일 앱이 아닌 문서 · 첫 줄이 아직 없을 때) — 머리 바탕 글자색.
  '#header #' + DRIVE_ACTIONS_ID + '{color:var(--gw-nc-hdr-fg,var(--color-background-plain-text,#ffffff))}',
  // 종 감싸개 — NC .header-menu 는 크기를 --header-height 로 잡는 것으로 보이는데(실측 0×0) 파일 앱에서 그 값을 0 으로 덮었다(:33) →
  // 34px 트리거가 첫 줄 오른쪽 밖으로 넘치고 17px 아래로 처진다(5aa7af 후속 · 할일 #2837).
  '#' + DRIVE_ACTIONS_ID + ' #' + BELL_ID + '{width:var(--default-clickable-area,34px) !important;'
    + 'height:var(--default-clickable-area,34px) !important;flex-shrink:0}',
  // 종을 본문 줄 크기로 · 머리 줄용 꼬리는 숨긴다.
  '#' + DRIVE_ACTIONS_ID + ' .header-menu__trigger{width:var(--default-clickable-area,34px) !important;'
    + 'height:var(--default-clickable-area,34px) !important}',
  '#' + DRIVE_ACTIONS_ID + ' .header-menu__carret{display:none !important}',
  // 좁은 화면은 AI 아이콘만.
  '@media (max-width:600px){#' + AI_BTN_ID + ' .gw-ai-btn-text{display:none}}',
].join('');

// 묶음을 둘 첫 줄 — .files-list__header, 없으면 경로 조각(.files-list__breadcrumbs)의 부모. 둘 다 없으면 null.
export function findFilesHeaderRow(doc) {
  try {
    if (!doc || typeof doc.querySelector !== 'function') return null;
    const row = doc.querySelector('.files-list__header');
    if (row) return row;
    const crumbs = doc.querySelector('.files-list__breadcrumbs');
    return (crumbs && crumbs.parentElement) || null;
  } catch (e) { return null; }
}

// style 을 head 에 1개만 — 폴링에서 수십 번 불린다(collabSkinNc upsertStyle 과 같은 모양).
function upsertStyle(doc) {
  if (!doc.head) return;
  const found = doc.getElementById(DRIVE_ACTIONS_STYLE_ID);
  if (found) {
    if (found.textContent !== DRIVE_ACTIONS_CSS) found.textContent = DRIVE_ACTIONS_CSS;
    return;
  }
  const st = doc.createElement('style');
  st.id = DRIVE_ACTIONS_STYLE_ID;
  st.textContent = DRIVE_ACTIONS_CSS;
  doc.head.appendChild(st);
}

function hover(el) {
  el.addEventListener('mouseenter', () => { el.style.background = HOVER_BG; });
  el.addEventListener('mouseleave', () => { el.style.background = 'transparent'; });
}

// AI — NC Assistant(사내 Claude 연결)를 연다. 클릭 동작은 옛 EmbedPage 머리 줄 AI 버튼 그대로.
function makeAiButton(doc, o) {
  const btn = doc.createElement('button');
  btn.id = AI_BTN_ID;
  btn.type = 'button';
  btn.title = o.botName;
  btn.innerHTML = o.iconSvg + '<span class="gw-ai-btn-text" style="margin-left:5px">AI</span>';
  const b = btn.style;
  b.display = 'flex'; b.alignItems = 'center'; b.background = 'transparent'; b.border = 'none'; b.margin = '0';
  b.color = 'inherit'; b.cursor = 'pointer'; b.fontWeight = '600'; b.fontSize = '14px';
  b.height = 'var(--default-clickable-area, 34px)'; b.minHeight = '0'; b.padding = '0 10px';
  b.borderRadius = '17px'; b.whiteSpace = 'nowrap';
  hover(btn);
  btn.addEventListener('click', () => {
    try {
      const w = doc.defaultView;
      const A = w && w.OCA && w.OCA.Assistant;
      if (A && A.openAssistantForm) {
        const p = A.openAssistantForm({ appId: 'assistant', identifier: 'gw-drive-ai', input: '' });
        if (p && typeof p.catch === 'function') p.catch(() => {});
      } else {
        w.alert(o.botName + '를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.');
      }
    } catch (e) { /* */ }
  });
  return btn;
}

// 관리자 전용 — 정리 전 원본 NC 를 새 창으로(글자·title 은 옛 addNcOriginLink 그대로).
function makeOriginButton(doc, o) {
  const a = doc.createElement('button');
  a.id = ORIGIN_BTN_ID;
  a.type = 'button';
  a.title = '관리자: 정리 전 원본 Nextcloud 화면을 새 창으로 엽니다';
  a.textContent = 'NC 원본 열기';
  const s = a.style;
  s.display = 'flex'; s.alignItems = 'center'; s.background = 'transparent'; s.border = '1px solid var(--color-border, #e5e5e2)';
  s.color = 'inherit'; s.cursor = 'pointer'; s.fontSize = '12px'; s.fontWeight = '600'; s.margin = '0 2px 0 0';
  s.height = '30px'; s.minHeight = '0'; s.padding = '0 10px'; s.borderRadius = '15px'; s.whiteSpace = 'nowrap';
  hover(a);
  a.addEventListener('click', () => { try { o.openOrigin(); } catch (e) { /* */ } });
  return a;
}

// 묶음 확보 — 떨어져 있어도 doc 속성에 든 같은 묶음을 쓴다. 순서 = [원본 열기(관리자)] [AI] [종].
function ensureGroup(doc, o) {
  let group = doc[GROUP_KEY];
  if (!group) {
    group = doc.getElementById(DRIVE_ACTIONS_ID);
    if (!group) {
      group = doc.createElement('div');
      group.id = DRIVE_ACTIONS_ID;
    }
    doc[GROUP_KEY] = group;
  }
  if (!group.querySelector('#' + AI_BTN_ID)) group.insertBefore(makeAiButton(doc, o), childById(group, BELL_ID));
  if (o.isAdmin && !group.querySelector('#' + ORIGIN_BTN_ID)) group.insertBefore(makeOriginButton(doc, o), group.firstChild);
  return group;
}

// insertBefore 기준은 직계 자식이어야 한다(없으면 null = 끝에 붙임).
function childById(parent, id) {
  const kids = parent.children || [];
  for (let i = 0; i < kids.length; i += 1) {
    if (kids[i].id === id) return kids[i];
  }
  return null;
}

// NC 종을 묶음 끝으로 — 묶음이 문서에 붙어 있을 때만(떨어진 묶음에 넣으면 NC 가 #notifications 를 못 찾는다).
function moveBell(doc, group) {
  const root = doc.documentElement;
  if (!root || !root.contains(group)) return;
  const bell = doc.getElementById(BELL_ID);
  if (!bell || group.contains(bell) || bell.contains(group)) return;
  const stale = group.querySelector('#' + BELL_ID);   // NC 가 종을 새로 그렸다 — 떨어져 남은 옛 종은 뺀다(종 1개)
  if (stale && stale.parentNode) stale.parentNode.removeChild(stale);
  group.appendChild(bell);
}

// 배치 — 첫 줄(없으면 머리 줄 .header-end)의 마지막 자식. 이미 그 줄에 있으면 그대로(옵저버와 핑퐁하지 않게).
function place(doc, group) {
  const target = findFilesHeaderRow(doc) || doc.querySelector('#header .header-end');
  if (!target) return;
  if (group.parentNode !== target) target.appendChild(group);
  moveBell(doc, group);
}

// 알림 창 위치 — NC 는 창 top 을 머리 줄 높이에 맞추는데, 그 값이 0 이 되면 창이 종을 덮는다.
function fixBellPanel(win, group) {
  const panel = group.querySelector('.header-menu__wrapper');
  if (!panel || !win || typeof win.getComputedStyle !== 'function') return;
  const cs = win.getComputedStyle(panel);
  if (!cs || cs.display === 'none' || cs.visibility === 'hidden') return;
  let top = 'calc(100% + ' + PANEL_GAP_PX + 'px)';
  if (cs.position === 'fixed') {
    const trigger = group.querySelector('.header-menu__trigger') || group.querySelector('#' + BELL_ID);
    if (!trigger) return;
    top = Math.round(trigger.getBoundingClientRect().bottom + PANEL_GAP_PX) + 'px';
  }
  panel.style.setProperty('top', top, 'important');
}

// 매번 불러도 멱등(style·묶음·배치). 옵저버·클릭 리스너는 doc 당 1회 설치하고 그때만 dispose 를 돌려준다(그 밖엔 null).
// options: { isAdmin, botName, iconSvg, openOrigin(), isActive() }
export function setupDriveActions(doc, options) {
  const opts = options || {};
  const o = {
    isAdmin: !!opts.isAdmin,
    botName: (typeof opts.botName === 'string' && opts.botName) ? opts.botName : BOT_NAME,
    iconSvg: typeof opts.iconSvg === 'string' ? opts.iconSvg : '',
    openOrigin: (typeof opts.openOrigin === 'function') ? opts.openOrigin : () => {},
  };
  const isActive = (typeof opts.isActive === 'function') ? opts.isActive : () => true;
  let group = null;
  let win = null;
  try {
    if (!doc || !doc.body) return null;
    upsertStyle(doc);
    group = ensureGroup(doc, o);
    place(doc, group);
    win = doc.defaultView || null;
  } catch (e) { return null; }
  // 🔴 doc·win 양쪽에 표시 — 같은 오리진 첫 이동(about:blank → NC)은 Window 를 재사용한다. 그래서 win 표시는 «그 doc»
  //    이고, 새 문서면 다시 설치한다(옛 문서 body 옵저버는 새 문서를 못 본다).
  try {
    if (doc[GUARD_KEY] || (win && win[GUARD_KEY] === doc)) return null;
    doc[GUARD_KEY] = true;
    if (win) win[GUARD_KEY] = doc;
  } catch (e) { return null; }

  let disposed = false;
  let timer = null;
  let obs = null;
  const rerun = () => {
    timer = null;
    if (disposed) return;
    try {
      if (!isActive()) return;
      place(doc, ensureGroup(doc, o));
    } catch (e) { /* */ }
  };
  try {
    const MO = (win && win.MutationObserver) || (typeof MutationObserver !== 'undefined' ? MutationObserver : null);
    if (MO) {
      obs = new MO(() => {
        if (disposed || timer) return;
        try { if (!isActive()) return; } catch (e) { return; }
        timer = setTimeout(rerun, DEBOUNCE_MS);
      });
      obs.observe(doc.body, { childList: true, subtree: true });
    }
  } catch (e) { obs = null; }

  // 종을 누르면 NC 가 창을 연 뒤(rAF 2회) 위치를 고친다. rAF 가 없으면 setTimeout.
  const raf = (cb) => {
    try { if (win && typeof win.requestAnimationFrame === 'function') return win.requestAnimationFrame(cb); } catch (e) { /* */ }
    return setTimeout(cb, 16);
  };
  const fixPanel = () => {
    if (disposed) return;
    try { fixBellPanel(win, group); } catch (e) { /* */ }
  };
  const onClick = () => {
    if (disposed) return;
    raf(() => raf(fixPanel));
  };
  try { group.addEventListener('click', onClick); } catch (e) { /* */ }

  // 해제 = 옵저버·리스너·가드만. 묶음과 종은 그대로 둔다.
  return function dispose() {
    if (disposed) return;
    disposed = true;
    try { if (obs) obs.disconnect(); } catch (e) { /* */ }
    try { if (timer) clearTimeout(timer); } catch (e) { /* */ }
    timer = null;
    try { group.removeEventListener('click', onClick); } catch (e) { /* */ }
    try { delete doc[GUARD_KEY]; } catch (e) { doc[GUARD_KEY] = false; }
    try { if (win && win[GUARD_KEY] === doc) delete win[GUARD_KEY]; } catch (e) { /* */ }
  };
}
